<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`text_question_${_uid}`"
    mode="eager"
    slim
    rules="required"
  >
    <v-textarea
      v-model="questionValue"
      outlined
      flat
      hide-details="auto"
      aria-label="Antwortfeld Textfrage"
      append-icon="mdi-comment-outline"
      :placeholder="$t('pleaseProvide')"
      :error-messages="errors"
      v-bind="$attrs"
    />
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },

    question: {
      type: Object,
      required: true
    }
  },

  computed: {
    questionValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
